import {Directive, EventEmitter, HostBinding, HostListener, Output,} from "@angular/core";

@Directive({
    selector: "[appDnd]",
})
export class DndDirective {
    @Output() fileDropped = new EventEmitter<{ target: DataTransfer }>();
    @HostBinding("class.fileover") fileOver: boolean;

    @HostListener("dragover", ["$event"])
    onDragOver(e: DragEvent) {
        e.preventDefault();
        e.stopPropagation();

        this.fileOver = true;
    }

    @HostListener("dragleave", ["$event"])
    onDragLeave(e: DragEvent) {
        e.preventDefault();
        e.stopPropagation();

        this.fileOver = false;
    }

    @HostListener("drop", ["$event"])
    onDrop(e: DragEvent) {
        e.preventDefault();
        e.stopPropagation();

        this.fileOver = false;
        const files = e.dataTransfer.files;

        if (files.length > 0) {
            this.fileDropped.emit({
                target: e.dataTransfer,
            });
        }
    }
}
